module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', {
    staticClass: "s-actionsheet"
  }, [_c('c-navbar', {
    attrs: {
      "share": _vm.canShare
    }
  }), _vm._v(" "), _c('c-content', [_c('c-panel-container', _vm._l((_vm.panelItems), function(item) {
    return _c('c-panel', {
      key: item.title,
      attrs: {
        "img": item.img,
        "title": item.title,
        "desc": item.desc
      }
    }, [_c('div', [_c('h4', {
      staticClass: "price",
      domProps: {
        "innerHTML": _vm._s(item.price)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ori-discount",
      domProps: {
        "innerHTML": _vm._s(item.oriPrice)
      }
    })])])
  })), _vm._v(" "), _c('c-images', {
    attrs: {
      "img-items": _vm.images
    }
  }), _vm._v(" "), (Number(_vm.resId) === _vm.Goods.saas.advanced.id) ? _c('div', {
    staticClass: "overlay-text"
  }, [_c('div', {
    staticClass: "overlay-mask overlay-mask-one",
    on: {
      "click": _vm.openLaws
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay-mask overlay-mask-two",
    on: {
      "click": _vm.goToProtocol
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('c-footer', {
    staticClass: "footer-shadow"
  }, [_c('c-button', {
    nativeOn: {
      "click": function($event) {
        _vm.buy($event)
      }
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.btnText))])])], 1), _vm._v(" "), _c('c-action-sheet', {
    attrs: {
      "visible": _vm.actionsheetShow
    },
    on: {
      "update:visible": function($event) {
        _vm.actionsheetShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closeActionSheet
    }
  }, [_c('i', {
    staticClass: "s-icon-times-circle-o"
  })]), _vm._v(" "), _c('div', {
    slot: "menu"
  }, [_c('div', {
    staticClass: "action-wrap"
  }, [_c('action-modal')], 1)])])], 1), _vm._v(" "), _c('c-share', {
    attrs: {
      "visible": _vm.share.shareVisible,
      "config": _vm.share.config
    },
    on: {
      "update:visible": function($event) {
        _vm.share.shareVisible = $event
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1027340c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/details/value-added-service/index.vue
// module id = 1018
// module chunks = 2